// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3Y-8m","header":"MergedInvoice_header__239iw"};